import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Users from "./pages/Users/Users";
import Roles from "./pages/Users/Roles/Roles";
import Permissions from "./pages/Users/Permissions/Permissions";
import Report from "./pages/Report/Report";
import Plans from "./pages/Plans/Plans";
import ReleaseNote from "./pages/ReleaseNote/ReleaseNote.jsx";
import Profile from "./pages/Profile/Profile";
import Sources from "./pages/Sources/Sources";
import ProtectedRoute from "./components/common/ProtectedRoute";
import ChooseService from "./pages/Authentication/ChooseService";
import Analytics from "./pages/Analytics/Analytics";
import NotificationTriggers from "./pages/NotificationEngine/NotificationTriggers";
import EventTracking from "./pages/EventTracking/EventTracking";

const OverAll = lazy(() => import("./pages/subscribers/OverAll/OverAll"));
const Subscription = lazy(() => import("./pages/Subscription/Subscription"));
const Churn = lazy(() => import("./pages/subscribers/Churn/Churn"));
const Competition = lazy(
  () => import("./pages/Competitions/Competition/Competition")
);
const Quiz = lazy(() => import("./pages/Competitions/Quiz/Quiz"));
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const Revenue = lazy(() => import("./pages/Revenue/Revenue"));
const Login = lazy(() => import("./pages/Authentication/Login"));
const Signup = lazy(() => import("./pages/Authentication/Signup"));

const ForgotPassword = lazy(
  () => import("./pages/Authentication/ForgotPassword")
);
const ResetPassword = lazy(
  () => import("./pages/Authentication/ResetPassword")
);
const PasswordSuccess = lazy(
  () => import("./pages/Authentication/PasswordSuccess")
);
const Leaderboard = lazy(() => import("./pages/Leaderboard/Leaderboard"));
const Settings = lazy(() => import("./pages/Settings/Settings"));

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback="Loading...">
            <Navigate to="/service" />
          </Suspense>
        }
      />
      <Route
        path="/login"
        element={
          <Suspense fallback="Loading...">
            <Login />
          </Suspense>
        }
      />
      <Route
        path="/createaccount"
        element={
          <Suspense fallback="Loading...">
            <Signup />
          </Suspense>
        }
      />
      <Route
        path="/forgot"
        element={
          <Suspense fallback="Loading...">
            <ForgotPassword />
          </Suspense>
        }
      />
      <Route
        path="/reset"
        element={
          <Suspense fallback="Loading...">
            <ResetPassword />
          </Suspense>
        }
      />
      <Route
        path="/success"
        element={
          <Suspense fallback="Loading...">
            <PasswordSuccess />
          </Suspense>
        }
      />

<Route
          path="/service"
          element={
            <Suspense fallback="Loading...">
              <ChooseService />
            </Suspense>
          }
        />
      <Route element={<ProtectedRoute />}>
        <Route
          path="/dashboard"
          element={
            <Suspense fallback="Loading...">
              <Dashboard />
            </Suspense>
          }
        />
        
        <Route
          path="/revenue"
          element={
            <Suspense fallback="Loading...">
              <Revenue />
            </Suspense>
          }
        />
        <Route
          path="/subscriptions"
          element={
            <Suspense fallback="Loading...">
              <Subscription />
            </Suspense>
          }
        />
        <Route
          path="/subscribers/overall"
          element={
            <Suspense fallback="Loading...">
              <OverAll />
            </Suspense>
          }
        />
        <Route
          path="/subscribers/churn"
          element={
            <Suspense fallback="Loading...">
              <Churn />
            </Suspense>
          }
        />
        <Route
          path="/churn"
          element={
            <Suspense fallback="Loading...">
              <Churn />
            </Suspense>
          }
        />
        <Route
          path="/competitions/competitions"
          element={
            <Suspense fallback="Loading...">
              <Competition />
            </Suspense>
          }
        />
        <Route
          path="/competitions/quiz"
          element={
            <Suspense fallback="Loading...">
              <Quiz />
            </Suspense>
          }
        />
        <Route
          path="/competitions/winners-statistic"
          element={
            <Suspense fallback="Loading...">
              <Leaderboard />
            </Suspense>
          }
        />
        <Route
          path="/users/users"
          element={
            <Suspense fallback="Loading...">
              <Users />
            </Suspense>
          }
        ></Route>
        <Route
          path="/users/roles"
          element={
            <Suspense fallback="Loading...">
              <Roles />
            </Suspense>
          }
        />
        <Route
          path="/users/permissions"
          element={
            <Suspense fallback="Loading...">
              <Permissions />
            </Suspense>
          }
        />
        <Route
          path="/report"
          element={
            <Suspense fallback="Loading...">
              <Report />
            </Suspense>
          }
        />
        <Route
          path="/plans"
          element={
            <Suspense fallback="Loading...">
              <Plans />
            </Suspense>
          }
        />
        <Route
          path="/sources"
          element={
            <Suspense fallback="Loading...">
              <Sources />
            </Suspense>
          }
        />
        <Route
          path="/profile"
          element={
            <Suspense fallback="Loading...">
              <Profile />
            </Suspense>
          }
        />
         <Route
          path="/analytics-overview"
          element={
            <Suspense fallback="Loading...">
              <Analytics />
            </Suspense>
          }
        />
         <Route
          path="/event-tracking"
          element={
            <Suspense fallback="Loading...">
              <EventTracking />
            </Suspense>
          }
        />
         <Route
          path="/notification-engine"
          element={
            <Suspense fallback="Loading...">
              <NotificationTriggers />
            </Suspense>
          }
        />
        <Route
          path="/settings"
          element={
            <Suspense fallback="Loading...">
              <Settings />
            </Suspense>
          }
        />
        <Route
          path="/rel_note"
          element={
            <Suspense fallback="Loading...">
              <ReleaseNote />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
